import React from "react";
import Chart from "react-apexcharts";

const BarChart = () => {
  const options = {
    series: [
      {
        name: "Asset 1A",
        data: [95000, 75000, 50000, 75000, 50000, 80000, 75000],
      },
      {
        name: "Asset 1B",
        data: [70000, 55000, 40000, 65000, 40000, 90000, 65000],
      },
    ],
    options: {
      chart: {
        type: "bar",
        height: 430,
      },
      plotOptions: {
        bar: {
          horizontal: false,
          dataLabels: {
            position: "top",
          },
        },
      },
      dataLabels: {
        enabled: false,
        offsetX: -6,
        style: {
          fontSize: "12px",
          colors: ["#fff"],
        },
      },
      stroke: {
        show: true,
        width: 1,
        colors: ["#fff"],
      },
      tooltip: {
        shared: true,
        intersect: false,
      },
      xaxis: {
        categories: [
          "Oct 01",
          "Oct 05",
          "Oct 10",
          "Oct 15",
          "Oct 20",
          "Oct 25",
          "Oct 30",
        ],
      },
    },
  };

  return (
    <div>
      <Chart
        options={options.options}
        series={options.series}
        type="bar"
        height={320}
      />
    </div>
  );
};

export default BarChart;
